import PropTypes from 'prop-types';
import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from 'react';

const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    console.log('WebSocketProvider: Initializing WebSocket connection');
    const token = sessionStorage.getItem('accessToken');
    console.log('WebSocketProvider: Retrieved token:', token);

    if (!token) {
      console.error('WebSocketProvider: No token found in sessionStorage');
      return;
    }

    const wsUrl = `${process.env.REACT_APP_WEBSOCKET_HOST_API}/ws/notifications/?token=${token}`;
    console.log('WebSocketProvider: Connecting to WebSocket URL:', wsUrl);
    const ws = new WebSocket(wsUrl);

    ws.onopen = () => {
      console.log('WebSocketProvider: WebSocket connection established');
    };

    ws.onmessage = (event) => {
      console.log('WebSocketProvider: Received WebSocket message:', event.data);
      try {
        const data = JSON.parse(event.data);
        console.log('WebSocketProvider: Parsed message data:', data);
        if (data.message) {
          console.log('WebSocketProvider: Adding new notification:', data.message);
          setNotifications((prev) => [
            ...prev,
            {
              id: Date.now(), // Replace with notification.id if provided by backend
              message: data.message,
              isRead: data.is_read || false,
              sender: data.sender || 'System',
              createdAt: data.created_at || new Date().toISOString(),
              type: data.type || 'Test',
              text: data.text || {}
            },
          ]);
        } else if (data.error) {
          console.error('WebSocketProvider: Server returned error:', data.error);
        } else {
          console.warn('WebSocketProvider: Unknown message format:', data);
        }
      } catch (error) {
        console.error('WebSocketProvider: Error parsing message:', error);
      }
    };

    ws.onclose = (event) => {
      console.log('WebSocketProvider: WebSocket connection closed. Code:', event.code, 'Reason:', event.reason);
    };

    ws.onerror = (error) => {
      console.error('WebSocketProvider: WebSocket error:', error);
    };

    setSocket(ws);
    console.log('WebSocketProvider: WebSocket instance set:', ws);

    // return () => {
    //   if (ws) {
    //     ws.close();
    //   }
    // };
  }, []);

  const markNotificationAsRead = useCallback((id) => {
    console.log('WebSocketProvider: Marking notification as read. ID:', id);
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.id === id ? { ...notif, isRead: true } : notif
      )
    );
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({ action: 'mark_as_read', notification_id: id }));
    }
  }, [socket]);

  const contextValue = useMemo(() => ({
    notifications,
    markNotificationAsRead,
  }), [notifications, markNotificationAsRead]);

  console.log('WebSocketProvider: Current notifications state:', notifications);

  return (
    <WebSocketContext.Provider value={contextValue}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);

WebSocketProvider.propTypes = {
  children: PropTypes.node,
};